import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, Rect, G, ClipPath } from "react-native-svg";

export default function HealthBigIcon(props) {
  const width = props.width || 290;
  const height = props.height || 264;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 290 264"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_big_health)">
          <Path
            d="M264.438 101.033H39.7458V226.318H264.438V101.033Z"
            fill="#3F3D56"
          />
          <Path
            d="M47.8614 111.708L62.6549 106.149C58.3732 100.956 52.6821 95.6507 46.6757 90.6873L26.2666 94.1416L43.1155 87.8111C28.2569 76.0644 12.8234 66.8872 12.8234 66.8872C12.8234 66.8872 -4.0463 114.11 0.912384 135.087C3.78851 147.255 11.539 156.859 21.2547 161.903L21.65 134.797L26.9274 164.253C32.5653 166.051 38.586 166.286 44.3467 164.931C63.3761 160.436 74.7827 139.786 69.8241 118.809C69.0813 115.667 67.2783 112.3 64.7558 108.848L47.8614 111.708Z"
            fill="#D0CDE1"
          />
          <Path
            opacity="0.1"
            d="M50.1726 158.563C55.102 155.718 58.3109 152.049 57.3399 150.368C56.3689 148.686 51.5858 149.63 46.6564 152.475C41.727 155.32 38.5181 158.989 39.4891 160.67C40.46 162.352 45.2432 161.408 50.1726 158.563Z"
            fill="black"
          />
          <Path
            d="M107.317 226.318H87.1045C84.2062 223.599 81.5018 220.68 79.0111 217.583L64.9205 193.846L47.2656 164.095L45.3008 160.788L43.6853 158.065L52.4166 153.217L54.2725 155.69L54.6347 156.171L56.763 159.004L71.0972 178.091L72.6646 163.762H78.4854L73.7063 181.565L107.317 226.318Z"
            fill="#F2F2F2"
          />
          <Path
            d="M234.723 112.957L217.983 111.287C220.966 104.773 225.368 97.7585 230.187 91.0091L252.128 88.978L233.062 87.0761C245.131 70.9266 258.495 57.2629 258.495 57.2629C258.495 57.2629 288.779 101.225 289.422 124.162C289.795 137.465 284.451 149.466 275.838 157.314L268.009 129.537L270.646 161.283C265.339 164.676 259.209 166.564 252.912 166.747C232.106 167.329 214.717 149.208 214.075 126.272C213.978 122.836 214.911 118.88 216.561 114.639L234.723 112.957Z"
            fill="#D0CDE1"
          />
          <Path
            opacity="0.1"
            d="M256.743 161.035C257.281 159.04 252.975 156.143 247.125 154.565C241.276 152.988 236.097 153.326 235.558 155.321C235.02 157.316 239.325 160.213 245.175 161.791C251.025 163.368 256.204 163.03 256.743 161.035Z"
            fill="black"
          />
          <Path
            d="M251.713 159.5L251.614 159.856L250.797 162.75L249.681 166.688V166.691L239.664 202.12L232.908 226.014C232.792 226.116 232.677 226.215 232.558 226.318H213.352L227.263 191.892L217.474 174.887L223.462 173.295L228.997 187.601L238.517 164.05L238.52 164.047L239.931 160.551L240.171 159.955L241.402 156.902L251.393 159.424L251.713 159.5Z"
            fill="#F2F2F2"
          />
          <Path
            d="M124.052 234.425L116.05 264H143.452L146.605 261.091L147.817 264H177.16C177.16 264 180.312 244.849 176.432 243.395C172.552 241.94 124.052 234.425 124.052 234.425Z"
            fill="#2F2E41"
          />
          <Path
            d="M154.85 117.823C164.091 117.823 171.582 110.335 171.582 101.097C171.582 91.8589 164.091 84.3701 154.85 84.3701C145.609 84.3701 138.117 91.8589 138.117 101.097C138.117 110.335 145.609 117.823 154.85 117.823Z"
            fill="#A0616A"
          />
          <Path
            d="M142.361 109.46C142.361 109.46 145.514 133.217 140.664 135.883C135.814 138.55 169.521 138.792 169.521 138.792C169.521 138.792 162.003 118.187 165.398 111.884L142.361 109.46Z"
            fill="#A0616A"
          />
          <Path
            d="M153.637 131.883C153.637 131.883 145.148 130.616 143.33 126.401L117.748 137.701C117.748 137.701 122.355 171.397 125.023 177.458L121.628 238.304C121.628 238.304 145.392 254.061 177.402 245.576L185.405 178.67L194.135 138.914L166.184 127.692C166.184 127.692 160.67 131.399 153.637 131.883Z"
            fill="#239C9D"
          />
          <Path
            d="M171.34 208.487C171.34 208.487 140.542 207.517 142.725 216.729C144.907 225.941 173.28 216.244 173.28 216.244L171.34 208.487Z"
            fill="#A0616A"
          />
          <Path
            d="M140.93 85.2751L137.801 84.023C137.801 84.023 144.343 76.8237 153.444 77.4497L150.884 74.6326C150.884 74.6326 157.141 72.1285 162.83 78.7018C165.82 82.1572 169.28 86.2189 171.436 90.7943H174.787L173.388 93.8723L178.283 96.9503L173.259 96.3974C173.559 98.0829 173.605 99.8037 173.396 101.503C173.18 103.202 172.312 104.752 170.976 105.824C170.976 105.824 167.096 97.7956 167.096 96.5436V99.6737C167.096 99.6737 163.967 96.8566 163.967 94.9785L162.261 97.1696L161.408 93.7265L150.884 97.1696L152.591 94.3525L146.049 95.2916L148.609 91.8484C148.609 91.8484 141.214 95.9176 140.93 99.3607C140.646 102.804 138.481 106.066 138.481 106.066C138.481 106.066 132.682 89.9703 140.93 85.2751Z"
            fill="#2F2E41"
          />
          <Path
            d="M161.276 198.655V202.781C161.276 202.819 161.261 202.855 161.234 202.882C161.207 202.909 161.17 202.924 161.132 202.925H161.03V224.419C161.03 225.014 160.793 225.584 160.372 226.005C159.952 226.426 159.381 226.662 158.786 226.662H145.351C144.756 226.662 144.185 226.426 143.765 226.005C143.344 225.584 143.108 225.014 143.108 224.419V203.678H143.034C143.007 203.678 142.981 203.668 142.962 203.649C142.943 203.63 142.932 203.604 142.932 203.577V201.229C142.932 201.202 142.943 201.176 142.962 201.157C142.981 201.138 143.007 201.127 143.034 201.127H143.108V200.243H143.033C143.005 200.243 142.978 200.231 142.958 200.211C142.938 200.191 142.927 200.164 142.927 200.136V197.82C142.927 197.792 142.938 197.765 142.958 197.745C142.978 197.725 143.005 197.714 143.033 197.713H143.108V196.506H143.032C143.019 196.506 143.007 196.504 142.996 196.499C142.984 196.494 142.974 196.487 142.965 196.479C142.956 196.47 142.949 196.459 142.945 196.448C142.94 196.437 142.937 196.424 142.937 196.412V195.148C142.937 195.123 142.947 195.099 142.965 195.081C142.983 195.063 143.007 195.053 143.032 195.053H143.108V192.494C143.108 191.899 143.344 191.329 143.765 190.908C144.185 190.488 144.756 190.251 145.351 190.251H158.786C159.381 190.251 159.951 190.488 160.372 190.908C160.793 191.329 161.029 191.899 161.03 192.494V198.511H161.132C161.17 198.511 161.207 198.526 161.234 198.553C161.261 198.58 161.276 198.616 161.276 198.655Z"
            fill="#3F3D56"
          />
          <Path
            d="M152.091 202.025C153.306 202.025 154.29 201.041 154.29 199.827C154.29 198.612 153.306 197.628 152.091 197.628C150.876 197.628 149.891 198.612 149.891 199.827C149.891 201.041 150.876 202.025 152.091 202.025Z"
            fill="#F2F2F2"
          />
          <Path
            d="M186.617 138.914H194.134C194.134 138.914 218.142 191.276 212.322 197.578C206.502 203.881 171.34 221.093 171.34 221.093C171.34 221.093 168.672 207.76 166.247 207.76L190.497 192.73L178.614 164.367L186.617 138.914Z"
            fill="#239C9D"
          />
          <Path
            d="M132.782 206.305C132.782 206.305 160.185 220.85 155.092 227.153C150 233.456 125.507 216.002 125.507 216.002L132.782 206.305Z"
            fill="#A0616A"
          />
          <Path
            d="M121.142 137.944H117.747C117.747 137.944 112.898 142.55 111.443 152.974L97.3544 184.356C96.9285 185.305 96.7165 186.336 96.7336 187.376C96.7507 188.416 96.9963 189.44 97.4531 190.374C100.58 196.775 108.809 211.22 121.142 215.517L127.447 220.365C127.447 220.365 126.72 208.487 136.662 208.487L119.687 190.063L126.235 168.731L121.142 137.944Z"
            fill="#239C9D"
          />
          <Path d="M235.758 0H152.252V64.3963H235.758V0Z" fill="#3F3D56" />
          <Path
            d="M178.364 23.188H166.7V53.9286H178.364V23.188Z"
            fill="#D0CDE1"
          />
          <Path
            d="M199.837 35.113H188.173V53.9284H199.837V35.113Z"
            fill="#D0CDE1"
          />
          <Path
            d="M221.31 10.4678H209.646V53.9286H221.31V10.4678Z"
            fill="#D0CDE1"
          />
          <Path
            d="M194.005 29.0181C197.226 29.0181 199.837 26.4079 199.837 23.188C199.837 19.9681 197.226 17.3579 194.005 17.3579C190.784 17.3579 188.173 19.9681 188.173 23.188C188.173 26.4079 190.784 29.0181 194.005 29.0181Z"
            fill="#239C9D"
          />
          <Path
            d="M132.059 12.3848H48.5537V76.781H132.059V12.3848Z"
            fill="#3F3D56"
          />
          <Path
            d="M61.2783 63.531C61.2783 63.531 62.0736 42.0656 77.9794 45.5106C93.8851 48.9557 117.479 29.0803 117.479 29.0803"
            fill="#239C9D"
          />
          <Path
            d="M61.4108 62.4711V21.3953H56.1089V62.4711V67.5059V67.7712H124.504V62.4711H61.4108Z"
            fill="#D0CDE1"
          />
          <Path
            d="M140.505 168.744L143.407 172.129C144.485 171.924 145.611 171.682 146.771 171.411L145.937 168.744L147.975 171.121C160.262 168.1 175.491 162.227 175.491 162.227C175.491 162.227 159.05 163.432 146.774 160.751C141.342 159.565 135.754 162.257 133.525 167.348C132.229 170.308 132.433 172.872 137.028 172.872C138.58 172.845 140.128 172.7 141.659 172.436L140.505 168.744Z"
            fill="#2F2E41"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_big_health">
            <Rect width="289.44" height="264" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
